<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="onCreateItem()">
        <i class="fas fa-plus"></i> 新增合同
      </el-button>
      <div class="former">
        <el-input
          v-model="form.Key"
          placeholder="合同编号、名称或签订人"
          @keydown.enter.native="onSubmitQuery"
        ></el-input
        >&nbsp;
        <select2
          v-model="form.ClientID"
          url="client"
          labelName="ClientName"
          placeholder="请选择客户"
          no-data-text="无客户"
          :urlParams="urlParams"
          q="ClientName:like"
          :qinwhere="true"
          :queryOne="false"
        ></select2
        >&nbsp;
        <el-select
          v-model="form.VirtualStatus"
          clearable
          placeholder="状态"
          style="width: 100px"
        >
          <el-option label="启动" :value="1"></el-option>
          <el-option label="关闭" :value="2"></el-option>
          <el-option label="撤销" :value="3"></el-option>
        </el-select>
        &nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table
      :data="itemList"
      v-loading="loading"
      size="medium"
      tooltip-effect="light"
      style="margin-top: -15px"
    >
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      ></el-table-column>
      <el-table-column
        prop="ContractNumber"
        label="合同编号"
        width="190"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag>
            {{ scope.row.ContractNumber }}
          </el-tag>
          <el-tag type="success" v-if="scope.row.WithContract">
            {{ scope.row.WithContract.ContractNumber }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="合同名称" align="center">
        <template slot-scope="scope">
          <div>
            {{ scope.row.Name }}
          </div>
          <div>
            <el-tag>
              <el-tooltip content="Top center" placement="top" effect="light">
                <div slot="content">
                  <div>计划销售台数:{{ scope.row.DciSaleNum }} / 实际销售台数:{{ scope.row.DciActSaleNum }}</div>
                </div>
                <i
                  class="fa fa-cart-shopping fa-lg"
                  style="cursor: pointer"
                ></i>
              </el-tooltip>
              {{ scope.row.DciSaleNum }} / {{ scope.row.DciActSaleNum }}
            </el-tag>
            <el-tag type="success">
              <el-tooltip content="Top center" placement="top" effect="light">
                <div slot="content">
                  <div>计划现场实施台数:{{ scope.row.DciImplementationNum }} / 实际现场实施台数:{{ scope.row.DciActImplementationNum }}</div>
                </div>
                <i
                  class="fa fa-screwdriver-wrench fa-lg"
                  style="cursor: pointer"
                ></i>
              </el-tooltip>
              {{ scope.row.DciImplementationNum }} / {{ scope.row.DciActImplementationNum }}
            </el-tag>
            <el-tag type="warning">
              <el-tooltip content="Top center" placement="top" effect="light">
                <div slot="content">
                  <div>计划远程实施台数:{{ scope.row.DciImplementationRemoteNum }} / 实际远程实施台数:{{ scope.row.DciActImplementationRemoteNum }}</div>
                </div>
                <i
                  class="fa fa-screwdriver-wrench fa-lg"
                  style="cursor: pointer"
                ></i>
              </el-tooltip>
              {{ scope.row.DciImplementationRemoteNum }} / {{ scope.row.DciActImplementationRemoteNum }}
            </el-tag>
            <el-tag type="danger">
              <el-tooltip content="Top center" placement="top" effect="light">
                <div slot="content">
                  <div>售后现场实施台数:{{ scope.row.DciAfterImplementationNum }} / 售后远程实施台数:{{ scope.row.DciAfterImplementationRemoteNum }}</div>
                </div>
                <i
                  class="fa fa-screwdriver-wrench fa-lg"
                  style="cursor: pointer"
                ></i>
              </el-tooltip>
              {{ scope.row.DciAfterImplementationNum }} / {{ scope.row.DciAfterImplementationRemoteNum }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="合同类型" align="center" width="60">
        <template slot-scope="scope">
          <div v-if="scope.row.ContractType">
            {{ scope.row.ContractType.Name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="所属客户" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.Client">{{ scope.row.Client.ClientName }}</div>
        </template>
      </el-table-column>
      <el-table-column label="所属部门/交易买方" align="center" width="95">
        <template slot-scope="scope">
          <div v-if="scope.row.Department">
            {{ scope.row.Department.Name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="业务组分类" align="center" width="95">
        <template slot-scope="{ row }">
          <el-tag
            v-for="(code, index) in row.BusinessGroups"
            :key="index"
            style="margin-right: 5px; color: #00b3ca"
            >{{ getBusinessGroup(code) }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="日期信息" align="center">
        <el-table-column label="签订日期" align="center" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.CheckDay">
              {{ scope.row.CheckDay.substring(0, 10) }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="开始/结束日期" align="center" width="120">
          <template slot-scope="scope">
            <div v-if="scope.row.ContractStartDay">
              {{ scope.row.ContractStartDay.substring(0, 10) }}
            </div>
            <div v-if="scope.row.ContractEndDay">
              {{ scope.row.ContractEndDay.substring(0, 10) }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        prop="Amount"
        align="center"
        label="合同金额"
        width="90"
      />
      <!-- <el-table-column prop="ActualAmount" align="center" label="实收金额" width="90" /> -->
      <el-table-column
        prop="SignName"
        align="center"
        label="签订人"
        width="70"
      />
      <el-table-column width="70" align="center" label="状态">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.VirtualStatus === 2" type="info">
            关闭
          </el-tag>
          <el-tag v-else-if="scope.row.VirtualStatus === 3" type="danger">
            撤销
          </el-tag>
          <el-tag v-else type="success"> 启动 </el-tag>
        </template>
      </el-table-column>
      <el-table-column width="100" align="center" label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="onEditItem(scope.row)"
            title="编辑"
          >
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            :disabled= "scope.row.VirtualStatus === 2 || scope.row.VirtualStatus === 3"
            title="删除"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>
    <item-form
      v-model="item"
      :visible.sync="itemVisible"
      @form:saved="getItemList"
    />
  </el-card>
</template>

<script>
import ItemForm from "./index--form.vue";

export default {
  components: {
    ItemForm,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      businessGroupList: [],
      form: {
        Key: "",
        ClientID: "",
        VirtualStatus: "",
        BusinessGroups: [],
      },
      item: this.getEmptyItem(),
      itemVisible: false,
      urlParams: { where: {} },
    };
  },
  mounted() {
    this.getBusinessGroupList();
    this.getItemList();
  },
  created() {},
  methods: {
    // 获取
    getItemList() {
      this.loading = true;
      this.$axios
        .get("dci/contractVirtual", {
          params: {
            where: {
              "ContractNumber|Name|SignName:like": this.form.Key,
              ClientID: this.form.ClientID,
              IsVirtually: 1,
              VirtualStatus: this.form.VirtualStatus,
            },
            BusinessGroups: ["Dci_BusinessGroup"],
            with: ["Client", "Platforms", "ContractType", "WithContract", "Department"],
            ...this.pager,
            order: ["-check_day"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //业务组分类
    getBusinessGroupList() {
      this.$axios
        .get("basic", {
          params: {
            type: "BusinessGroup",
          },
        })
        .then((response) => {
          this.businessGroupList = response.data.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    getBusinessGroup(code) {
      let name = "";
      this.businessGroupList.forEach((item) => {
        if (item.Type === code) {
          name = item.Name;
        }
      });
      return name;
    },
    getContractList() {
      this.$axios
        .get("dci/product/stock-contracts")
        .then((response) => {
          this.contractList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    // 查询
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    // 翻页
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    // 编辑
    onEditItem(row) {
      this.item = row;
      this.itemVisible = true;
    },
    // 删除
    onDeleteItem(row) {
      this.$confirm("确定要删除此合同吗？", "提示")
        .then(() => this.$axios.delete(`contract/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("成功删除");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    // 新增
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.item.BusinessGroups = ["Dci_BusinessGroup"];
      this.itemVisible = true;
    },
    // item置空
    getEmptyItem() {
      return {
        CheckDay: new Date(),
        ContractStartDay: new Date(),
        Amount: 0,
        ActualAmount: 0,
        IsVirtually: true,
        VirtualStatus: 1,
        DciSaleNum: 0,
        DciImplementationNum: 0,
        DciImplementationRemoteNum: 0,
        DciActImplementationNum: 0,
        DciActImplementationRemoteNum: 0,
        DciAfterImplementationNum: 0,
        DciAfterImplementationRemoteNum: 0,
        QATime: 1,
      };
    },
  },
};
</script>
